module.exports = __webpack_public_path__ + "media/images/howitworks-art-2-b4672c4c9b0f6a1409b5ab208152a677.svg";